import Constant from "@/common/constant/Constant";
import Utils from "@/common/utils/utils";
import { I18n } from "aws-amplify";
import { cloneDeep, constant } from 'lodash';
import LogKibanaConstant from "@/common/constant/LogKibanaConstant";
import TelephoneConstant from "@/common/constant/TelephoneConstant";


export const getSystemFieldNameInDrillDown = (field) => {
    let name = '';

    switch (field) {
        case 'form':
            name = 'フォーマット名';
            break;
        case Constant.DRILLDOWN_TYPE_TEXT.TICKET_TYPE:
            name = I18n.get('TICKET_TYPE_DRILLDOWN');
            break;
        case 'affiliationProject':
            name = '所属先プロジェクト';
            break;
        case 'creator':
            name = '投稿ユーザー';
            break;
        case 'updator':
            name = '更新ユーザー';
            break;
        case Constant.DRILLDOWN_TYPE_TEXT.EMAIL_TICKET_ORIGIN:
            name = I18n.get('EMAIL_TICKET_ORIGIN_DRILLDOWN_TEXT');
            break;
        case 'proxiedUser':
            name = '代理投稿者';
            break;
        case 'publicRange':
            name = '公開範囲';
            break;
        case 'suffixOfAttachments':
            name = '添付データ種類';
            break;
        case Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING:
            name = '外部連携設定';
            break
        
        // Update for helpdesk list
        case 'projectOrigin':
            name = I18n.get('USER08LB001');
            break;
        case 'projectTarget':
            name = I18n.get('USER08LB002');
            break;
        case 'liveOrArchived':
            name = 'Active/Archived';
            break;
        case 'noticeTargetUser':
            name = I18n.get('USER08LB003');
            break;
        case 'personInCharge':
            name = I18n.get('USER04LB054');
            break;
        case Constant.DRILLDOWN_TYPE_TEXT.TELEPHONE_EVALUATOR:
            name = TelephoneConstant.SYSTEM_FIELD_LABEL.TELEPHONE_EVALUATOR;
            break;
        case 'privateBookmark':
            name = I18n.get('個人用ブックマークタグ');
            break;
        case 'sharedBookmark':
            name = I18n.get('共有ブックマークタグ');
            break;
        default:
            break;
    }

    return name;
}

export const getChildNameInDrillDown = (key, data) => {
    let childName = '';
    switch (key) {
        case 'form':
        case Constant.DRILLDOWN_TYPE_TEXT.TICKET_TYPE:
            childName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, data.name);
            break;
        case 'creator':
        case 'updator':
        case 'proxiedUser':
        case 'noticeTargetUser':
        case 'personInCharge':
        case Constant.DRILLDOWN_TYPE_TEXT.TELEPHONE_EVALUATOR:
            childName = Utils.getUserNameInDrilldown(data);
            if(data.corporationActive){
                if(data.corporationActive === Constant.CORPORATION_ACTIVE.BLOCK){
                    childName = `${childName} (${Constant.SUFFIX_TEXT.BLOCK_CORPORATION})`
                }
                if(data.corporationActive === Constant.CORPORATION_ACTIVE.DELETED){
                    childName = `${childName} (${Constant.SUFFIX_TEXT.DELETED_CORPORATION})`
                }
            }
            break;
        case 'privateBookmark':
            childName = data;
            break;
        case 'sharedBookmark':
            childName = data
            break;
        case Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING:
            childName = data
            break;
        default:
            break;
    }

    return childName;
}

export const getPublicRangeName = (type) => {
    let name = '';

    switch (type) {
        case Constant.KNOWLEDGE_PUBLIC_RANGE.ONLY_ME:
            name = '自分のみ';
            break;
        case Constant.KNOWLEDGE_PUBLIC_RANGE.PROJECT_ONLY:
            name = 'プロジェクト内';
            break;
        case Constant.KNOWLEDGE_PUBLIC_RANGE.CORPORATION_ONLY:
            name = '組織内';
            break;
        case Constant.KNOWLEDGE_PUBLIC_RANGE.ALL:
            name = '組織外';
            break;

        default:
            break;
    }

    return name;
};

export const emailTicketOriginName = (type) => {
    let name = '';

    switch (type) {
        case Constant.DRILLDOWN_TYPE.EMAIL_TICKET_SDESK_SEND:
            name = 'プロジェクト';
            break;
        case Constant.DRILLDOWN_TYPE.EMAIL_TICKET_SDESK_RECEIVE:
            name = 'カスタマー';
            break;
        default:
            break;
    }

    return name;
};

/**
 * selectDrilldown
 * @param {*} argsCommon 
 * @param {*} item 
 * @param {*} itemChild 
 * @returns 
 */
export const selectDrilldown = (argsCommon, item, itemChild) => {
    let currentStructure = cloneDeep(argsCommon.viewStructure);
    let itemId = item.id;
    let childId = itemChild.id;

    if (!itemId || !childId) {
        return;
    }

    let isSelected = isSelectedOption(currentStructure, item, childId);
    if (isSelected) {
        return;
    }

    let objField = {};

    // not put ticketCreatedProjectId in fields of structure
    if (itemId !== Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID) {
        objField[itemId] = childId;
    }

    if (
        item.usage === Constant.DRILLDOWN_USAGE.STATUS &&
        itemId !== Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID
    ) {
        if (!Utils.isEmptyArray(itemChild.listStatusId)) {
            let arrFilterFieldStatus = [];
            itemChild.listStatusId.forEach(statusItem => {
                let objFilterStatusItem = {};
                objFilterStatusItem[statusItem.fieldId] = statusItem.statusId;
                arrFilterFieldStatus.push(objFilterStatusItem);
            });
            currentStructure.statusFields = arrFilterFieldStatus;
        }
        // if (currentStructure.hasOwnProperty('statusFields')) {
        //     currentStructure.statusFields.push(objField);
        // } else {
        //     currentStructure.statusFields = [objField];
        // }
    } else if (item.usage === Constant.DRILLDOWN_USAGE.TAG) {
        if (currentStructure.hasOwnProperty('tagFields')) {
            currentStructure.tagFields.push(objField);
        } else {
            currentStructure.tagFields = [objField];
        }
    } else if (itemId === 'privateBookmark' || itemId === 'sharedBookmark') {
        objField = {
            bookmarkId: childId,
            userSelectId: argsCommon?.userDetail?.id,
            projectSelectId: argsCommon?.projectInuseDetail?.id
        }

        if (currentStructure.hasOwnProperty(itemId)) {
            currentStructure[itemId].push(objField);
        } else {
            currentStructure[itemId] = [objField];
        }
    } else if (itemId === Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING) {
        if (currentStructure.hasOwnProperty(itemId)) {
            currentStructure[itemId].push(childId);
        } else {
            currentStructure[itemId] = [childId];
        }
    } else {
        if (currentStructure.hasOwnProperty('fields')) {
            currentStructure.fields.push(objField);
        } else {
            currentStructure.fields = [objField];
        }
    }

    if (argsCommon.setViewStructure) {
        if (item.id === Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID) {
            currentStructure.ticketCreatedProjectId = itemChild.id;
            argsCommon?.setDestinationPrjId(itemChild.id);
        }

        argsCommon.setViewStructure(currentStructure);
    }

    if (argsCommon.lastUserAction !== LogKibanaConstant.SEARCH_ACTION.DRILL_DOWN) {
        argsCommon.setLastUserAction(LogKibanaConstant.SEARCH_ACTION.DRILL_DOWN);
    }

    if (Constant.PANEL_TYPE.HELPDESK_TICKET_LIST === argsCommon.parentPanel) {
        let listTagSuggest = [...argsCommon.searchTagSuggest];
        let tagSuggest = itemChild.label + '@' + item.label;
        listTagSuggest.push(tagSuggest);
        argsCommon.setSearchTagSuggest(listTagSuggest);
    } else if (Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST === argsCommon.parentPanel) {
        let listTagSuggest = [...argsCommon.searchTagSuggestKnowledge];
        let tagSuggest = itemChild.label + '@' + item.label;
        listTagSuggest.push(tagSuggest);
        argsCommon.setSearchTagSuggestKnowledge(listTagSuggest);
    } else {
        let listTagSuggest = [...argsCommon.searchPublicTagSuggest];
        let tagSuggest = itemChild.label + '@' + item.label;
        listTagSuggest.push(tagSuggest);
        argsCommon.setSearchPublicTagSuggest(listTagSuggest);
    }

    return currentStructure;
};

/**
 * isSelectedOption
 * @param {*} viewStructure 
 * @param {*} itemData 
 * @param {*} childId 
 * @returns 
 */
export const isSelectedOption = (viewStructure, itemData, childId) => {
    let listSelectedAll = [];
    let listSelectedSystem = !Utils.isEmptyArray(viewStructure?.fields) ? viewStructure.fields : [];
    let listSelectedStatus = !Utils.isEmptyArray(viewStructure?.statusFields) ? viewStructure.statusFields : [];
    let listSelectedTag = !Utils.isEmptyArray(viewStructure?.tagFields) ? viewStructure.tagFields : [];
    let privateBookmark = !Utils.isEmptyArray(viewStructure?.privateBookmark) ? viewStructure.privateBookmark : [];
    let shareBookmark = !Utils.isEmptyArray(viewStructure?.sharedBookmark) ? viewStructure.sharedBookmark : [];
    let mcpServerSetting = !Utils.isEmptyArray(viewStructure?.mcpServerSetting) ? viewStructure.mcpServerSetting : [];

    listSelectedAll = listSelectedSystem.concat(listSelectedStatus, listSelectedTag,privateBookmark,shareBookmark, mcpServerSetting);

    if (Utils.isEmptyArray(listSelectedAll)) {
        return false;
    }
    let isSelected = false;
    for (const selectedOption of listSelectedAll) {
        switch (true) {
            case itemData.usage === Constant.DRILLDOWN_USAGE.STATUS && !Utils.isEmptyArray(listSelectedStatus):
                isSelected = true;
                break;
            case itemData.usage === Constant.DRILLDOWN_USAGE.TAG && selectedOption.hasOwnProperty(itemData.id) && selectedOption[itemData.id] === childId:
                isSelected = true;
                break;
            case itemData.usage === Constant.DRILLDOWN_USAGE.SYSTEM && selectedOption.hasOwnProperty(itemData.id) && ![Constant.FORMAT_OPTION_SEARCH.SUFFIX_OF_ATTACHMENTS, Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID,Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK,Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK].includes(itemData.id):
                isSelected = true;
                break;
            case itemData.usage === Constant.DRILLDOWN_USAGE.SYSTEM && selectedOption.hasOwnProperty(itemData.id) && itemData.id === Constant.FORMAT_OPTION_SEARCH.SUFFIX_OF_ATTACHMENTS && selectedOption[itemData.id] === childId:
                isSelected = true;
                break;
            case itemData.usage === Constant.DRILLDOWN_USAGE.SYSTEM && [Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK,Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK].includes(itemData.id) && selectedOption.bookmarkId === childId:
                isSelected = true;
                break;
            case itemData.usage === Constant.DRILLDOWN_USAGE.SYSTEM && itemData.id === Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING && selectedOption === childId:
                isSelected = true;
                break;
            default:
                break;
        }
    }

    return isSelected;
}

/**
 * isSelectedDrilldownField
 * @param {*} item 
 * @param {*} viewStructure 
 * @returns 
 */
export const isSelectedDrilldownField = (item, viewStructure) => {
    let itemId = item.id;
    let isSelected = false;

    if (item.id === Constant.FORMAT_OPTION_SEARCH.TICKET_CREATED_PROJECT_ID) {
        return false;
    }

    if((itemId === 'privateBookmark' || itemId === 'sharedBookmark')){
        let isAllBookmarkSelected = checkSelectedBookMarkItem(item, viewStructure);
        isSelected = isAllBookmarkSelected
        return isSelected        
    }

    if((itemId === Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING)){
        let isAllMcpSettingSelected = checkSelectedSettingMcpItem(item, viewStructure);
        isSelected = isAllMcpSettingSelected
        return isSelected        
    }

    if (!Utils.isEmptyArray(viewStructure.fields)) {
        for (const field of viewStructure.fields) {
            if (field && field.hasOwnProperty(itemId) && (itemId !== 'suffixOfAttachments' || (itemId === 'suffixOfAttachments' && isSelectedAllDrillDownAttachment(item, viewStructure)))) {
                isSelected = true;
                break;
            } 
        }
    }

    if (!Utils.isEmptyArray(viewStructure.statusFields) && item.usage === Constant.DRILLDOWN_USAGE.STATUS) {
        isSelected = true;
    }

    if (!Utils.isEmptyArray(viewStructure.tagFields)) {
        for (const field of viewStructure.tagFields) {
            if (field && field.hasOwnProperty(itemId) && isSelectedAllDrillDownTag(item, viewStructure)) {
                isSelected = true;
                break;
            } 
        }
    }

    return isSelected;
}

export const checkSelectedBookMarkItem = (item,viewStructure) => {
    let bookmarkOption = viewStructure[item.id];
    let itemClone = cloneDeep(item)
    if(Utils.isEmptyArray(bookmarkOption) || Utils.isEmptyArray(item.child)){
        return false;
    }else{
        let listChildSelectedId = bookmarkOption?.map(option =>  option.bookmarkId);
        let child = item.child?.filter(childElement => !listChildSelectedId.includes(childElement.id))
        itemClone.child = child;
        return child?.length ? false : true
    };
}

export const checkSelectedSettingMcpItem = (item,viewStructure) => {
    let mcpOption = viewStructure[Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING];
    let itemClone = cloneDeep(item)
    if(Utils.isEmptyArray(mcpOption) || Utils.isEmptyArray(item.child)){
        return false;
    }else{
        let child = item.child?.filter(childElement => !mcpOption.includes(childElement?.id))
        itemClone.child = child;
        return child?.length ? false : true
    };
}

/**
 * isSelectedAllDrillDownAttachment
 * @param {*} item 
 * @param {*} viewStructure 
 * @returns 
 */
export const isSelectedAllDrillDownAttachment = (item, viewStructure) => {
    let listOptionsAttachment = viewStructure.fields;
    let listCurrentFieldSelected = listOptionsAttachment.filter(option => option.hasOwnProperty(item.id));

    return listCurrentFieldSelected.length === item.child?.length;
}

/**
 * isSelectedAllDrillDownTag
 * @param {*} item 
 * @param {*} viewStructure 
 * @returns status
 */
export const isSelectedAllDrillDownTag = (item, viewStructure) => {
    const listOptionsTag = viewStructure.tagFields;
    
    // Early return if no options available
    if (Utils.isEmptyArray(listOptionsTag)) {
        return false;
    }

    // Calculate selected items once
    const listCurrentFieldSelected = listOptionsTag.filter(option => option.hasOwnProperty(item.id));
    
    // Single choice tag: return true if any item is selected
    if (item?.isMultiple === false) {
        return listCurrentFieldSelected.length > 0;
    }

    // Multiple choice tag: check if all children are selected
    return listCurrentFieldSelected.length === item.child?.length;
}

export const handleChangeSearchMethod = (e, argsCommon) => {
    let newMethod = e.target.value;
    if (!newMethod) return;

    let newViewStructure = cloneDeep(argsCommon.viewStructure);
    if (newViewStructure.options.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR) {
        newViewStructure.options['sort'] = argsCommon.optionsSort;
    }
    newViewStructure.options.method = newMethod;
    if (newMethod === Constant.SETTING_SEARCH_KEYWORD.SIMILAR) {
        argsCommon.setOptionsSort(newViewStructure.options['sort']);
        newViewStructure.options['sort'] = Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SIMILAR;
        newViewStructure.options['isSearchSynonym'] = 0;
        newViewStructure.options['isIncludeAttachPdf'] = 1;
        newViewStructure.options['isIncludePdfPage'] = 1;
        argsCommon.setIsDisableSynonymSearch(true)
        argsCommon.setIsDisableIncludeAttachPdf(true)
    } else {
        argsCommon.setIsDisableSynonymSearch(false)
        argsCommon.setIsDisableIncludeAttachPdf(false)
    }
    argsCommon.setViewStructure(newViewStructure);
}

export const handleChangeSearchPdfOption = (checked, optionName, args) => {
    let value = checked ? 1 : 0
    let newViewStructure = cloneDeep(args.viewStructure);
    newViewStructure.options[`${optionName}`] = value;

    args.setViewStructure(newViewStructure);
};

export const handleOnChangeSearchSynonym = (checked, optionName, args) => {
    // console.log('handleChangeSearchPdfOption :>> ', 1);
    let value = checked ? 1 : 0;
    let newViewStructure = cloneDeep(args.viewStructure);
    newViewStructure.options[`${optionName}`] = value;

    args.setViewStructure(newViewStructure);
    if (value) {
        args.setIsDisableSimilarSearch(true);
        if (newViewStructure.options.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR) {
            handleChangeSearchMethod(
                {
                    target: {
                        value: Constant.SETTING_SEARCH_KEYWORD.AND
                    }
                },
                { ...args, viewStructure: newViewStructure }
            );
        }
    } else {
        args.setIsDisableSimilarSearch(false);
    }
};

export const handleChangeSearchAttribute = (e, argsCommon) => {
    let newAttribute = e.target.value;
    if (!newAttribute) return;

    let newViewStructure = cloneDeep(argsCommon.viewStructure);
    newViewStructure.options.attribute = newAttribute;
    argsCommon.setViewStructure(newViewStructure);
}

export const handleChangeSortType = (e, argsCommon) => {
    let newType = e.target.value;
    if (!newType || newType === argsCommon.viewStructure.options['sort']) return;

    let newViewStructure = cloneDeep(argsCommon.viewStructure);
    newViewStructure.options['sort'] = newType;
    argsCommon.setViewStructure(newViewStructure);
}


/**
 * onChangeSearchDateType
 * @param {*} type 
 * @param {*} argsCommon 
 */
export const onChangeSearchDateType = (argsCommon) => {
    let currentViewStructure = cloneDeep(argsCommon.viewStructure);

    let newType = Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO;
    if (currentViewStructure?.options?.searchDateType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO) {
        newType = Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.RANGE;
    }

    // Reset data when change type
    if (newType === Constant.KNOWLEDGE_DATE_SEARCH_OPTION.TYPE.AGO) {
        currentViewStructure.options['to'] = null;
        currentViewStructure.options['from'] = null;
    } else {
        currentViewStructure.options.searchDateAgoValue = 0;
        currentViewStructure.options.searchDateAgoUnit = Constant.KNOWLEDGE_DATE_SEARCH_OPTION.AGO_UNIT.DAY;
    }

    currentViewStructure.options.searchDateType = newType;
    argsCommon.setViewStructure(currentViewStructure);
}

/**
 * handleChangeSearchDateAgoUnit
 * @param {*} e 
 * @param {*} argsCommon 
 * @returns 
 */
export const handleChangeSearchDateAgoUnit = (e, argsCommon) => {
    let currentViewStructure = cloneDeep(argsCommon.viewStructure);
    let selectedValue = e.target.value;

    if (!selectedValue || selectedValue === currentViewStructure.options.searchDateAgoUnit) {
        return;
    }

    currentViewStructure.options.searchDateAgoUnit = selectedValue;
    argsCommon.setViewStructure(currentViewStructure);
}

/**
 * handleChangeSearchDateAgoValue
 * @param {*} e 
 * @param {*} argsCommon 
 */
export const handleChangeSearchDateAgoValue = (e, argsCommon) => {
    let newValue = parseInt(e.target.value);
    if (newValue > 9999) {
        newValue = 9999;
    } else if (newValue < 0) {
        newValue = 0;
    }
    let currentViewStructure = cloneDeep(argsCommon.viewStructure);
    currentViewStructure.options.searchDateAgoValue = newValue;
    argsCommon.setViewStructure(currentViewStructure);
}


/**
 * onChangeSelectedOptions
 * @param {*} e 
 * @param {*} selectedList 
 * @param {*} argsCommon 
 * @param {*} type 
 */
export const onChangeSelectedOptions = (e, selectedList, argsCommon, type) => {
    let viewStructure = cloneDeep(argsCommon.viewStructure);
    let selectedOptionList = [];
    let tagValue = []
    if (!Utils.isEmptyArray(selectedList)) {
        for (const selectedItem of selectedList) {
            let objSearch = {
                type: '',
                value: []
            };

            switch (selectedItem.usage) {
                case Constant.DRILLDOWN_USAGE.SYSTEM:
                    let valueSelectItem = selectedItem.id
                    if([Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK,Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK].includes(selectedItem.type)){
                        valueSelectItem = {
                            bookmarkId: selectedItem.id,
                            userSelectId: argsCommon?.userDetail.id,
                            projectSelectId: argsCommon?.projectInuseDetail.id
                        }
                    }
                    if(Constant.FORMAT_OPTION_SEARCH.MCP_SERVER_SETTING === selectedItem.type){
                        valueSelectItem = selectedItem.id
                    }
                    objSearch.type = selectedItem.type;
                    objSearch.value = [valueSelectItem];
                    break;
                case Constant.DRILLDOWN_USAGE.TAG:
                    objSearch.type = Constant.FORMAT_OPTION_SEARCH.TAG_FIELD;
                    objSearch.value = [`${selectedItem.type}:${selectedItem.id}`];
                    break;
                case Constant.DRILLDOWN_USAGE.STATUS:
                    objSearch.type = Constant.FORMAT_OPTION_SEARCH.STATUS_FIELD;
                    objSearch.value = [`${selectedItem.type}:${selectedItem.id}`];
                    break;
                default:
                    break;
            }

            selectedOptionList.push(objSearch);
            tagValue.push(selectedItem.label)
        }
    }

    let otherFieldsData = {}
    if (viewStructure.options.hasOwnProperty('otherFields')) {
        otherFieldsData = viewStructure.options['otherFields'];
    } else {
        otherFieldsData = {
            include: [],
            exclude: [],
        }
    }
    selectedOptionList = selectedOptionList.filter(item => {
        return item.type && item.value && item.value.length > 0;
    });
    if (type === 'include') {
        otherFieldsData.include = selectedOptionList;
        if (Constant.PANEL_TYPE.HELPDESK_TICKET_LIST === argsCommon.parentPanel) {
            argsCommon.setSearchContainAny(tagValue);
        } else {
            argsCommon.setSearchContainAnyKnowledge(tagValue);
        }
    } else {
        otherFieldsData.exclude = selectedOptionList;
        if (Constant.PANEL_TYPE.HELPDESK_TICKET_LIST === argsCommon.parentPanel) {
            argsCommon.setSearchNotInclude(tagValue);
        } else {
            argsCommon.setSearchNotIncludeKnowledge(tagValue);
        }
    }

    viewStructure.options['otherFields'] = otherFieldsData;
    argsCommon.setViewStructure(viewStructure);
}


/**
 * convertOptionsDataFromStructure
 * @param {*} selectedOption 
 * @param {*} optionsList 
 * @returns 
 */
export const convertOptionsDataFromStructure = (selectedOption, optionsList, argsCommon, type) => {
    let viewStructure = cloneDeep(argsCommon.viewStructure);
    if (Utils.isEmptyArray(optionsList)) {
        // reset include, exclude
        
        viewStructure.options['otherFields'] = {
            include: [],
            exclude: [],
        };
        // argsCommon.setViewStructure(viewStructure);
        return [];
    }

    if (Utils.isEmptyArray(selectedOption)) {
        return [];
    }

    let selectedOptionData = [];
    let optionValid = [];
    let selectedOptionFields = [];

    for (const option of selectedOption) {
        switch (option.type) {
            case Constant.FORMAT_OPTION_SEARCH.TAG_FIELD:
                optionValid = optionsList.filter(optionChild => optionChild.usage === Constant.DRILLDOWN_USAGE.TAG && !Utils.isEmpty(option.value) && option.value[0] === optionChild.groupId);
                selectedOptionData = selectedOptionData.concat(optionValid);
                break;
            case Constant.FORMAT_OPTION_SEARCH.STATUS_FIELD:
                optionValid = optionsList.filter(optionChild => optionChild.usage === Constant.DRILLDOWN_USAGE.STATUS && !Utils.isEmpty(option.value) && option.value[0] === optionChild.groupId);
                selectedOptionData = selectedOptionData.concat(optionValid);
                break;
            case Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK:
            case Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK:
                optionValid = optionsList.filter(optionChild => optionChild.type === option.type && !Utils.isEmpty(option.value) && option.value[0]?.bookmarkId === optionChild.id);
                selectedOptionData = selectedOptionData.concat(optionValid);
                break;
            default:
                optionValid = optionsList.filter(optionChild => optionChild.type === option.type && !Utils.isEmpty(option.value) && option.value[0] === optionChild.id);
                selectedOptionData = selectedOptionData.concat(optionValid);
                break;
        }

        if (!Utils.isEmptyArray(optionValid)) {
            selectedOptionFields.push(option);
        }
    }

    let otherFieldsData = {}
    if (viewStructure.options.hasOwnProperty('otherFields')) {
        otherFieldsData = viewStructure.options['otherFields'];
    } else {
        otherFieldsData = {
            include: [],
            exclude: [],
        }
    }

    if (type === 'include') {
        otherFieldsData.include = selectedOptionFields;
    } else {
        otherFieldsData.exclude = selectedOptionFields;
    }
    viewStructure.options['otherFields'] = otherFieldsData;
    
    if (!Utils.isEmptyArray(otherFieldsData.include) || !Utils.isEmptyArray(otherFieldsData.exclude)) {
        argsCommon.setViewStructure(viewStructure);
    }

    return selectedOptionData;
}


/**
 * getOptionListFromDrillDownData
 * @param {*} drillDownData 
 * @returns 
 */
export const getOptionListFromDrillDownData = (drillDownData, viewStructure) => {
    if (Utils.isEmptyArray(drillDownData)) {
        return [];
    }

    let optionList = [];

    for (const drillDown of drillDownData) {
        if (Utils.isEmptyArray(drillDown.child)) {
            continue;
        }

        // don't show call mode and follow up status in training view
        if (
            viewStructure?.ticketProperty === Constant.TICKET_PROPERTY.TRAINING &&
            [
                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_MODE,
                TelephoneConstant.TELEPHONE.SYSTEM_FIELD.FOLLOW_UP_STATUS
            ].includes(drillDown?.sysField)
        ) {
            continue;
        }

        for (const drillDownChild of drillDown.child) {
            if (!drillDownChild.label) continue;


            optionList.push({
                groupId: `${drillDown.id}:${drillDownChild.id}`,
                type: drillDown.id,
                id: `${drillDownChild.id}`,
                label: `${drillDownChild.label}/${drillDown.label}`,
                usage: drillDown.usage,
                labelForSearch: `${drillDownChild.label}${drillDown.label}`,
                listStatusId: !Utils.isEmptyArray(drillDownChild.listStatusId) ? drillDownChild.listStatusId : []
            });
        }
    }
    return optionList;
}



/**
 * showAllDrillDownItem
 * @param {*} argsCommon 
 * @param {*} item 
 * @param {*} type 
 * @returns 
 */
export const showAllDrillDownItem = (status, argsCommon, item, type) => {
    let currentDrillDown = cloneDeep(argsCommon.drillDownData);

    let currentItemIndex = Utils.findIndexInArrayById(item.id, currentDrillDown);
    if (currentItemIndex === -1) {
        return;
    }

    switch (type) {
        case 'childInOrg':
            currentDrillDown[currentItemIndex].isShowMoreChildInOrg = status;
            break;
        case 'childOutOrg':
            currentDrillDown[currentItemIndex].isShowMoreChildOutOrg = status;
            break;
        default:
            currentDrillDown[currentItemIndex].isShowMore = status;
            break;
    }

    argsCommon.setDrillDownData(currentDrillDown);
}


/**
 * removeTypingDate
 * @param {*} type 
 * @param {*} argsCommon 
 */
export const removeTypingDate = (type, argsCommon) => {
    let currentViewStructure = cloneDeep(argsCommon.viewStructure);

    if (type === 'from') {
        currentViewStructure.options['from'] = null;
    } else if (type === 'to') {
        currentViewStructure.options['to'] = null;
    }

    argsCommon.setViewStructure(currentViewStructure);
}

export const resetPageParams = (
    currentPageParams,
    setPageParams,
    setPublicKnowledgeEachPage,
    setTotalPage,
    setCountingItem
) => {
    setPublicKnowledgeEachPage(Constant.PUBLIC_KNOWLEDGE_PAGE.PAGE_SIZE);
    setPageParams(currentPageParams);
    setTotalPage({ page: 0 });
    setCountingItem(0);
};

/**
 * isDisplayOptionSearchSynonym
 * is display option search synonym in ticket list
 * @param {*} corporationDetail 
 * @param {*} projectInuseDetail 
 * @returns 
 */
export const isDisplayOptionSearchSynonym = (corporationDetail, projectInuseDetail) => {
    if (!corporationDetail || !projectInuseDetail) return false;

    let projectSetting = Utils.convertJSONDataToObject(projectInuseDetail.projectSetting);
    if (!projectSetting || !projectSetting.usingSynonym) return false;

    let corporationLimitValue = corporationDetail.limitValue;
    let inviterSetting = corporationDetail.inviterSetting
        ? Utils.convertJSONDataToObject(corporationDetail.inviterSetting)
        : {};

    return corporationLimitValue?.synonymSearch ||
        (corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK &&
            inviterSetting.synonymSearch)
        ? true
        : false;
};

export const isDisplayOptionSearchSynonymForKnowledgeList = (corporationDetail,projectInuseDetail,organizationProject,viewStructure) => {

    if(viewStructure.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
        return false;
    }

    switch (organizationProject.value) {
        case Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE:
        case Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG:
            return isDisplayOptionSearchSynonym(corporationDetail,projectInuseDetail);
        default:
            break;
    };

    const projectSelectedId = organizationProject.value;
    const internalProjectList = organizationProject.internalProjectList ? organizationProject.internalProjectList : [];
    const externalProjectList = organizationProject.externalProjectList ? organizationProject.externalProjectList : [];

    const listProjects = [...internalProjectList, ...externalProjectList];

    const projectSelectedInfo = listProjects.find(project => project.id === projectSelectedId);

    if(Utils.isEmptyObject(projectSelectedInfo)) return false

    if(projectSelectedInfo.affiliationOrganization === corporationDetail.id){
        return isDisplayOptionSearchSynonym(corporationDetail,projectSelectedInfo);
    }else{
        if(projectSelectedInfo.contractType === Constant.CORPORATION_CONTRACT_TYPE.PREMIUM){
            return isDisplayOptionSearchSynonym({ contractType:projectSelectedInfo.contractType, limitValue:projectSelectedInfo.limitValue},projectSelectedInfo);
        }

        if(projectSelectedInfo.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK){
            return isDisplayOptionSearchSynonym(corporationDetail,projectSelectedInfo);
        }
    }

    return true
}
